import { convertHTMLToRaw } from 'braft-convert';
export var htmlToPlainText = function htmlToPlainText(html) {
  var raw = convertHTMLToRaw(html);
  var plainText = raw.blocks.map(function (block) {
    return block.text;
  }).join('\n');
  return plainText;
};